export default __webpack_public_path__ + "static/media/ECE_white.c40b2dc6.svg";